<div
  class="w-full aspect-video relative overflow-hidden max-h-[calc(100vh-20rem)]"
  [class.card-header-image]="cardHeaderImage"
  [class.aspect-video]="!fullHeight"
>
  @if (images.length === 1) {

    @if (images[0].includes('.mp4')) {
      <video class="z-10 object-cover object-top w-full" autoplay muted loop controls
             [class.aspect-video]="!fullHeight">
        <source src="{{ images[0] }}" type="video/mp4">
      </video>
    } @else if (images[0].includes('.webm')) {
      <video class="z-10 object-cover object-top w-full" autoplay muted loop controls>
        <source src="{{ images[0] }}" type="video/webm">
      </video>
    } @else if (images[0].includes('.ogv')) {
      <video class="z-10 object-cover object-top w-full" autoplay muted loop controls>
        <source src="{{ images[0] }}" type="video/ogg">
      </video>
    } @else if (images[0].includes('.mov')) {
      <video class="z-10 object-cover object-top w-full" autoplay muted loop controls>
        <source src="{{ images[0] }}" type="video/quicktime">
      </video>
    } @else {
      <pinch-zoom [autoZoomOut]="true" [overflow]="'visible'" class="z-[100]" [backgroundColor]="'transparent'">
        <img src="{{ images[0] }}" alt="{{ alt }}" class="z-10 object-cover object-top w-full"
             [class.aspect-video]="!fullHeight"/>
      </pinch-zoom>
    }

  } @else if (images.length > 1) {
    <pinch-zoom [autoZoomOut]="true" [overflow]="'visible'" class="z-[100]" [backgroundColor]="'transparent'">
      <swiper-container #swiper pagination="true" pagination-dynamic-bullets="false" loop="true" auto-play="true">
        <swiper-slide *ngFor="let image of images">
          @if (image.includes('.mp4')) {
            <video class="z-10 object-cover object-top w-full" autoplay muted loop controls>
              <source src="{{ image }}" type="video/mp4">
            </video>
          } @else if (image.includes('.webm')) {
            <video class="z-10 object-cover object-top w-full" autoplay muted loop controls>
              <source src="{{ image }}" type="video/webm">
            </video>
          } @else if (image.includes('.ogv')) {
            <video class="z-10 object-cover object-top w-full" autoplay muted loop controls>
              <source src="{{ image }}" type="video/ogg">
            </video>
          } @else if (image.includes('.mov')) {
            <video class="z-10 object-cover object-top w-full" autoplay muted loop controls>
              <source src="{{ image }}" type="video/quicktime">
            </video>
          } @else {
            <img src="{{ image }}" alt="{{ alt }}" class="z-10 object-cover object-top w-full"
                 [class.aspect-video]="!fullHeight"/>
          }
        </swiper-slide>
        <div class="swiper-pagination"></div>
      </swiper-container>
    </pinch-zoom>
  }

  <ng-content></ng-content>
</div>
